import React from "react";
import ForgotPasswordForm from "../Components/Forms/ForgotPasswordForm";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    minWidth: "100%",
    background: "linear-gradient(to right bottom, #03ceac, #03bc9b)",
    padding: theme.spacing(1),
  },
  heading: {
    color: theme.palette.common.white,
  },
  link: {
    color: theme.palette.common.white,
  },
}));
const ForgotPassword = () => {
  const classes = useStyles();
  return (
    <Container className={classes.root}>
      <Typography component="div">
        <Box display="block" component="h1" className={classes.heading} p={1}>
          Reset your Password
        </Box>
        <Box display="block" component="div" alignContent="center">
          <ForgotPasswordForm />
        </Box>
        <Box display="block" component="div" p={1}>
          <Link href="/login" className={classes.link}>
            Return to Login Page
          </Link>
        </Box>
      </Typography>
    </Container>
  );
};

export default ForgotPassword;
